import { DashboardActivityLog } from "./DashboardActivityLog";

export const ActivityPage = () => (
  <section className="mx-auto w-full max-w-5xl p-4 md:p-8">
    <h1 className="mb-6 text-2xl font-semibold">Actividad</h1>
    <DashboardActivityLog />
  </section>
);
